import React, {Component} from 'react';
import classNames from 'classnames';

import reverseUrl from 'utils/urls';
import {RootCategoryProps} from 'utils/propTypes';
import CategorySelect from 'components/category_list/CategorySelect';

class RootCategory extends Component {
    static propTypes = {
        ...RootCategoryProps,
    };

    constructor(props) {
        super(props);
        this.state = {
            isOpened: null,
        };
    }

    isSelected() {
        const {id, selectedCategories} = this.props;
        return selectedCategories.includes(id);
    }

    url = () => {
        const baseUrl = this.isSelected() ? reverseUrl('catalogue:index') : this.props.url;
        return `${baseUrl}${window.location.search}`;
    };

    shouldOpen = () => {
        const {isOpened} = this.state;

        switch (isOpened) {
            case true:
                return true;
            case null:  // Initial state
                if (this.isSelected()) {
                    return true;
                } else if (this.props.selectedCategories.length > 1) {
                    return true;
                }
                return false;
            default:
                console.error('RootCategory.state.isOpened contains unexpected value');
                return false;
        }
    };

    renderCategory = category => (
        <CategorySelect
            key={`${category.id}-${category.slug}`}
            selectedCategories={this.props.selectedCategories}
            {...category}
        />
    );

    render() {
        const {id, name, slug, children} = this.props;
        const key = `${id}-${slug}`;
        const shouldOpen = this.shouldOpen();

        const caretClassNames = classNames("caret gray", {flip: shouldOpen});
        const content = this.isSelected() ? (
            <strong>{name}</strong>
        ) : name;

        const childrenCategories = (
            <ul>
                {children.map(this.renderCategory)}
            </ul>
        );

        return (
            <li key={key}>
                <span className="category-item">
                    <a href={this.url()}>
                        <span className="capitalize__first">{content}</span>
                    </a>

                    <div className="category-caret click-able" onClick={() => this.setState({isOpened: !shouldOpen})}>
                        <span className={caretClassNames} />
                    </div>
                </span>
                {shouldOpen ? childrenCategories : null}
            </li>
        );
    }
}


export default RootCategory;



// WEBPACK FOOTER //
// ./src/components/category_list/RootCategory.js